import React, { TextareaHTMLAttributes } from "react";
import { FieldError } from "react-hook-form";
import { Label } from "./Label";
import { Error } from "./Error";

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string;
  error?: string | FieldError;
  style?: React.CSSProperties;
};

export const TextArea = React.forwardRef<HTMLTextAreaElement, Props>(
  (props, ref) => {
    const { label, id, error, required, style, ...rest } = props;
    return (
      <>
        <Label label={label} htmlFor={id} required={required} />
        <textarea
          id={id}
          {...rest}
          ref={ref}
          className={`block py-4 px-3 w-full border  rounded-xl placeholder:text-sm ${
            error
              ? "border-danger focus:outline-danger"
              : "border-gray-200 focus:outline-secondary"
          }`}
          style={style ?? { minHeight: "130px", maxHeight: "130px" }}
        />
        {<Error error={error} />}
      </>
    );
  }
);
